import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import red_cross from "../../../../../Assets/svg/red-cross.svg";
import { userSchema } from "../../../../../helpers/yup_validator";
import { post, put } from "../../../../../helpers/api_helper";

const AddNewUser = ({
  showModal,
  setShowModal,
  setRefresh,
  mode,
  userData,
  resetFormOnClose,
}) => {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      status: "active",
      isEmailVerified: false,
    },
    validationSchema: userSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        if (mode === "create") {
          await post("/user/admin/user", { ...values });
          toast.success("User created successfully");
          formik.resetForm();
        } else if (mode === "edit") {
          await put(`/user/admin/user/${userData._id}`, { ...values });
          toast.success("User updated successfully");
        }
        setShowModal(false);
        setRefresh();
      } catch (error) {
        console.error("Error submitting user data:", error);
        setErrors({
          submissionError: error.response?.data?.message
            ? error.response?.data?.message
            : error.response?.data?.error || "An error occurred.",
        });
        toast.error(
          error.response?.data?.message
            ? error.response?.data?.message
            : error.response?.data?.error || "An error occurred."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (mode === "edit" && userData) {
      formik.setValues({
        name: userData.name || "",
        email: userData.email || "",
        status: userData.status || "active",
        isEmailVerified: userData.isEmailVerified || false,
      });
    } else if (resetFormOnClose) {
      formik.resetForm();
    }
  }, [mode, userData, resetFormOnClose]);

  return (
    <Modal
      show={showModal}
      size="md"
      onHide={() => setShowModal(false)}
      backdrop="static"
      keyboard={false}
      centered
      scrollable
    >
      <Modal.Body>
        <div className="topHeader d-flex align-items-start justify-content-between gap-10 pb-2">
          <div className="left">
            <h5 className="m-0 fw-sbold">
              {mode === "edit" ? "Edit User Account" : "Add New User Account"}
            </h5>
            <p className="m-0 text-muted">
              {mode === "edit"
                ? "Update user details below."
                : "Fill in the details to create a new user account."}
            </p>
          </div>
          <Button
            className="p-0 border-0"
            variant="transparent"
            onClick={() => setShowModal(false)}
          >
            <img src={red_cross} alt="" />
          </Button>
        </div>
        <div className="FormWrapper">
          {formik.errors.submissionError && (
            <div className="alert alert-danger">
              {formik.errors.submissionError}
            </div>
          )}
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col className="my-2" lg="12">
                <label htmlFor="name" className="form-label text-dark m-0 pb-1">
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formik.values.name}
                  placeholder="Full Name"
                  className={`form-control ${
                    formik.touched.name && formik.errors.name
                      ? "is-invalid"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-danger">{formik.errors.name}</div>
                ) : null}
              </Col>
              <Col className="my-2" lg="12">
                <label
                  htmlFor="email"
                  className="form-label text-dark m-0 pb-1"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formik.values.email}
                  placeholder="john@email.com"
                  className={`form-control ${
                    formik.touched.email && formik.errors.email
                      ? "is-invalid"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-danger">{formik.errors.email}</div>
                ) : null}
              </Col>

              {/* <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-between gap-10">
                  <label
                    htmlFor="status"
                    className="form-label text-dark fw-sbold m-0"
                  >
                    Status
                  </label>
                  <Form.Check
                    type="switch"
                    id="status"
                    name="status"
                    checked={formik.values.status === "active"}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "status",
                        e.target.checked ? "active" : "inactive"
                      )
                    }
                  />
                </div>
              </Col> */}
              {/* <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-between gap-10">
                  <label
                    htmlFor="isEmailVerified"
                    className="form-label text-dark fw-sbold m-0"
                  >
                    Verified
                  </label>
                  <Form.Check
                    type="switch"
                    id="isEmailVerified"
                    name="isEmailVerified"
                    checked={formik.values.isEmailVerified === true}
                    onChange={(e) =>
                      formik.setFieldValue(
                        "isEmailVerified",
                        e.target.checked ? true : false
                      )
                    }
                  />
                </div>
              </Col> */}
              <Col lg="12" className="my-2">
                <Button
                  className="d-flex align-items-center w-100 justify-content-center commonBtn"
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  {mode === "create" ? "Add User" : "Update User"}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddNewUser;
